function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Outline/Status/Info-circle"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.99984 7.16699C8.27598 7.16699 8.49984 7.39085 8.49984 7.66699V11.0003C8.49984 11.2765 8.27598 11.5003 7.99984 11.5003C7.72369 11.5003 7.49984 11.2765 7.49984 11.0003V7.66699C7.49984 7.39085 7.72369 7.16699 7.99984 7.16699Z",
  fill: "#737E98"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.99984 6.00033C8.36803 6.00033 8.6665 5.70185 8.6665 5.33366C8.6665 4.96547 8.36803 4.66699 7.99984 4.66699C7.63165 4.66699 7.33317 4.96547 7.33317 5.33366C7.33317 5.70185 7.63165 6.00033 7.99984 6.00033Z",
  fill: "#737E98"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.1665 8.00033C2.1665 4.77866 4.77818 2.16699 7.99984 2.16699C11.2215 2.16699 13.8332 4.77866 13.8332 8.00033C13.8332 11.222 11.2215 13.8337 7.99984 13.8337C4.77818 13.8337 2.1665 11.222 2.1665 8.00033ZM7.99984 3.16699C5.33046 3.16699 3.1665 5.33095 3.1665 8.00033C3.1665 10.6697 5.33046 12.8337 7.99984 12.8337C10.6692 12.8337 12.8332 10.6697 12.8332 8.00033C12.8332 5.33095 10.6692 3.16699 7.99984 3.16699Z",
  fill: "#737E98"
})));
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/Info-circle.0fd2792553a6d66e784453c2cd3d698f.svg";
export { ForwardRef as ReactComponent };